import Joi from 'joi'

/**
 * schema to create a new battery export
 */
export const batterExportSchema = Joi.object({
  emails: Joi.array().items(Joi.string()).min(1).required(),
  tables: Joi.object({
    batterydata: Joi.object({
      columns: Joi.array().items(Joi.string()).min(1).required(),
    }),
    batterydataExLG: Joi.object({
      columns: Joi.array().items(Joi.string()).min(1).required(),
    }),
    dcbdata: Joi.object({
      columns: Joi.array().items(Joi.string()).min(1).required(),
    }),
    dcbconfiguration: Joi.object({
      columns: Joi.array().items(Joi.string()).min(1).required(),
    }),
    batteryconfiguration: Joi.object({
      columns: Joi.array().items(Joi.string()).min(1).required(),
    }),
  }).min(1),
  jobs: Joi.array()
    .items(
      Joi.object({
        type: Joi.string().valid('sn', 'tc'),
        id: Joi.number().min(0).required(),
        from: Joi.number().min(0).required(),
        to: Joi.number().min(0).required(),
        dcb_history: Joi.array().items(
          Joi.object({
            serialno: Joi.number().integer().min(0).required(),
            tcSerialCode: Joi.string(),
            bat_index: Joi.number().integer().allow(0).required(),
            DCBAddr: Joi.number().integer().allow(0).required(),
            from: Joi.number().integer().min(0).unit('milliseconds').allow(0).required(),
            to: Joi.number().integer().greater(Joi.ref('from')).unit('milliseconds').allow(0).required(),
          })
        ),
      })
    )
    .min(1),
})
